import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DashboardLoader } from "../utils/Loading";
import { ServiceApi } from "../services/index.service";
import { setStorePermissions, storeSet } from "../redux/store/storeSlice";
import { Combobox } from "@headlessui/react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { Transition } from "react-transition-group";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Backdrop, CircularProgress } from "@mui/material";
import { runTour, showTourProgress, updateSteps } from "../redux/userOnboarding/userOnboardingSlice";
import { DASHBOARD_TOUR_STEPS } from "../utils/tourConstants";

const options = [
  {
    name: "Flavor Portal", //"Today's Flavors",
    id: 1,
    link: "",
    comp: "treatteam/flavors",
    text: "FlavorBoard",
  },
  {
    name: "Digital Recipe Portal",
    id: 2,
    link: "",
    comp: "treatteam/recipes",
    text: "DigitalRecipePortal",
  },
  {
    name: "Flavor Admin", //"Manage Flavors",
    id: 3,
    link: "",
    comp: "treatteam/manage-flavors",
    text: "FlavorAdmin",
  },
  {
    name: "Digital Menu Board",
    id: 4,
    link: "",
    comp: "treatteam/board-administration",
    text: "DigitalMenuBoard",
  },
  {
    name: "Digital Drive Thru Board", // "Drive Thru",
    id: 8,
    link: "",
    comp: "treatteam/drive-thru",
    text: "DigitalDriveThruBoard",
  },
  {
    name: "Flavor Driven Treat Admin", //"Manage Flavor Driven Treats",
    id: 9,
    link: "",
    comp: "treatteam/flavor-driven-treats",
    text: "FlavorDrivenTreatAdmin",
  },
  {
    name: "Hours of Operation",
    id: 10,
    link: "",
    comp: "treatteam/hours-of-operation",
    text: "HoursOfOperation",
  },
  {
    name: "Shop Website Customization", // "Website Customization",
    id: 11,
    link: "https://dmb.ritasice.com/",
    comp: "",
    text: "ShopWebsiteCustomization",
  },
  {
    name: "Cool Alerts",
    id: 13,
    link: "https://dmb.ritasice.com/",
    comp: "",
    text: "CoolAlerts",
  },
  // {
  //   name: "Online Order Portal",
  //   id: 14,
  //   link: "https://loyalty.ritasice.com/login",
  //   comp: "",
  //   text: "OnlineOrderPortal",
  // },
  // {
  //   name: "Pre-Sell Board Configuration",
  //   id: 15,
  //   link: "",
  //   comp: "pre-sell-board",
  //   text: "PreSellBoardConfiguration",
  // },
  {
    name: "Production Sheet",
    id: 16,
    link: "",
    comp: "treatteam/production",
    text: "ProductionSheet",
  },
  // {
  //   name: "Buy Merchandise",
  //   id: 17,
  //   link: "",
  //   comp: "treatteam/purchase-merchendise",
  //   text: "BuyMerchendize",
  // },
  // {
  //   name: "Online Ordering",
  //   id: 18,
  //   link: "https://loyalty.training.demotesturl.net/login",
  //   comp: "online-ordering",
  //   text: "OnlineOrdering"
  // },
  // {
  //   name: "Loyalty Portal",
  //   id: 19,
  //   link: "https://loyalty.training.demotesturl.net/login",
  //   comp: "loyalty-portal",
  //   text: "LoyaltyPortal"
  // },
  // {
  //   name: "Edit Options",
  //   id: 20,
  //   link: "https://dmb.ritasice.com/",
  //   comp: "",
  //   text: "EditOptions",
  // }
];

const DMBUserOptions = [
  {
    name: "Digital Menu Board",
    id: 1,
    link: "",
    comp: "dmb/board-administration",
    text: "DigitalMenuBoard",
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const TTDashboard = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch()
  const serviceapi = new ServiceApi();
  const { profile,storage, userOnboarding } = useSelector((state) => state);
  const [store, setStore] = React.useState(null);
  const [query, setQuery] = React.useState("");
  const [permissions, setPermissions] = React.useState(null);
  const [permissionLoading, setPermissionLoading] = React.useState(false);

  
  React.useEffect(() => {
    if(store && profile){
      fetchStorePermissions();
    }
  }, [store,profile]);

  React.useEffect(() => {
    if(storage?.store){
      setStore(storage?.store)
    }
  }, [storage?.store]);

  //Start the tour after store and permissions succesfully loaded
  const isInitialRender = React.useRef(true); // used to keep track of whether it is the initial render or not
  React.useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    if (!userOnboarding?.tourStatus?.dashboard) startDashboardTour();
  }, [permissions, userOnboarding?.tourStatus?.dashboard]);

  const startDashboardTour = () => {
    if (!permissionLoading) {
      dispatch(updateSteps(DASHBOARD_TOUR_STEPS));
      dispatch(showTourProgress());
      dispatch(runTour("dashboard"));
    }
  }

  const fetchStorePermissions = async () => {
    const req = {
      intStoreID: store?.intStoreID,
      role: profile?.role,
    };
    setPermissionLoading(true)
    const res = await serviceapi.fetchStorePermissions(req);
    setPermissionLoading(false)
    setPermissions(res);
    dispatch(setStorePermissions(res))
  };

  const openSite = (lnk) => {
    if (lnk.link !== "") {
      switch (lnk.text) {
        case "OnlineOrderPortal":
          let link=lnk.link
          switch(process.env.REACT_APP_ENVIRONMENT){
            case "UAT":
              link="https://ritasfranchises.okta.com/home/ritasfranchises_ooloyaltydashboardstage_1/0oa1uf4sx4rvWwVCl1d8/aln1uf4vg565PZTjI1d8"
              break;
            case "TRAIN":
              link="https://ritasfranchises.okta.com/home/ritasfranchises_ooloyaltydashboardstage_1/0oa1uf4sx4rvWwVCl1d8/aln1uf4vg565PZTjI1d8"
              break;
            case "PROD":
              link="https://ritasfranchises.okta.com/home/ritasfranchises_ooloyaltydashboard_1/0oa1ugzdlzwXqzkwU1d8/aln1ugzhpwkTzf3341d8"
              break;
            default:
              link=lnk.link
              break;
          }
          window.open(link);
          break;
        case "CoolAlerts":
          const coolAlertsUrl = `${process.env.REACT_APP_DMB_URL}/users/login/${store?.intRitasStoreID}/coolalerts/${profile?.role}`;
          window.open(coolAlertsUrl);
          break;
        case "ShopWebsiteCustomization":
          const shopWebsiteCustomizationUrl = `${process.env.REACT_APP_DMB_URL}/users/login/${store?.intRitasStoreID}/websiteextras/${profile?.role}`;
          window.open(shopWebsiteCustomizationUrl);
          break;
        case "EditOptions":
          const editOptionsUrl = `${process.env.REACT_APP_DMB_URL}/users/login/${store?.intRitasStoreID}/editoptions/${profile?.role}`;
          window.open(editOptionsUrl);
          break;
        // case "OnlineOrdering":
        //   window.open(lnk.link);
        //   break;
        // case "LoyaltyPortal":
        //   window.open(lnk.link);
        //   break;
        default:
          window.open(lnk.link);
          break;
      }
    } else {
      navigate(`/${lnk.comp}`);
    }
  };


  const havePermissionToView = (menu) => {
    return permissions?.[menu] === true
    // const env=process.env?.REACT_APP_ENVIRONMENT
    // return permissions?.[menu] === true  || (env==="TRAIN" && menu==="LoyaltyPortal") || (env==="TRAIN" && menu ==="OnlineOrdering")
  };


  const handleChangeStore = (val) => {
    setStore(val);
    dispatch(storeSet(val));
  };
  const handleStoreClick = () => {
    setStore("");
    dispatch(storeSet(""));
  };

  if (!profile) {
    return (
      <>
        {" "}
        <div className="site-card-wrapper">
          <div className="main-dashboard-container">
            <DashboardLoader />
          </div>
        </div>
      </>
    );
  }

  const dashboardTiles = pathname.includes('/dmb') ? DMBUserOptions : options;

  return (
    <>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Dashboard
            </h1>
          </div>
        </header>
        <main>
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={permissionLoading}
          >
            <CircularProgress color="inherit"  />
          </Backdrop>
          {!store ?
          (<div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4 m-4">
                    No Stores are available
                  </div>):(
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="px-4 py-8 sm:px-0 dashboard-tour-selector">
              <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {dashboardTiles.map((option) => {
                  return havePermissionToView(option.text) ? (
                    <div
                      onClick={() => openSite(option)}
                      className="bg-white dark:bg-gray-800 rounded shadow px-4 py-3 flex items-center cursor-pointer "
                    >
                      <div className="p-2 bg-primary text-white rounded">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-click"
                          width={32}
                          height={32}
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" />
                          <line x1={3} y1={12} x2={6} y2={12} />
                          <line x1={12} y1={3} x2={12} y2={6} />
                          <line x1="7.8" y1="7.8" x2="5.6" y2="5.6" />
                          <line x1="16.2" y1="7.8" x2="18.4" y2="5.6" />
                          <line x1="7.8" y1="16.2" x2="5.6" y2="18.4" />
                          <path d="M12 12l9 3l-4 2l-2 4l-3 -9" />
                        </svg>
                      </div>
                      <div className="ml-6">
                        <h3 className="mb-1 leading-5 text-gray-800 dark:text-gray-100 font-medium text-md">{`${option.name}`}</h3>
                      </div>
                    </div>
                  ) : (
                    ""
                  );
                })}
              </div>
            </div>
          </div>)}
        </main>
      </div>
    </>
  );
};

export default TTDashboard;
